"use strict";

exports.__esModule = true;
exports.EditableReportElement = EditableReportElement;
var _react = _interopRequireDefault(require("react"));
var _SelectionContext = require("../SelectionContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Displays an editable report.
 */
function EditableReportElement(props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 1024 : _props$width,
    _props$height = props.height,
    height = _props$height === void 0 ? 768 : _props$height;
  return /*#__PURE__*/_react["default"].createElement(_SelectionContext.EditableSelectionContextElement, _extends({}, props, {
    width: width,
    height: height
  }));
}